/* eslint-disable no-console */
/* eslint-disable react/prop-types */

import React from 'react'
import classNames from 'classnames'
import { Form } from 'react-final-form'

import ConditionAggregator from '@piconetworks/condition-aggregator'
import StripeDecorator from '@piconetworks/stripe-decorator'
import WizardSlider from '@piconetworks/wizard-slider'

import getFields from 'apps/lib/getFields'
import observers from 'apps/lib/observers'
import WizardRedux from 'common/pkgs/WizardRedux'

import styles from './CardEditor.module.scss'

const CardEditor = (props) => {
    const {
        CardElement,
        stripe,
        elements,
        linkColor,
        publisherName,
        publisherId,
        paymentMethodsData,
        defaultPaymentMethod,
        dispatch,
        deleteCard,
        onUpdateSuccess,
    } = props

    const paymentFields = getFields([{
        id: 'payment',
        title: 'Payment',
        description: 'payment description',
        type: 'Payment',
        required: true,
        order: 15,
        deleteCard,
    }])

    return (
        <WizardSlider
            title="Update your payment method."
            description=""
            backButton={false}
        >
            <WizardRedux.Step
                onSubmit={() => ({})}
                render={({
                    form,
                }) => (
                    <ConditionAggregator
                        Submit={({ disabled, isSubmitting }) => (
                            <div className={isSubmitting ? 'loadingSpinner' : ''}>
                                <input
                                    className={classNames(
                                        styles.btnSubmit,
                                        'btn btn-block',
                                    )}
                                    disabled={disabled}
                                    style={{ backgroundColor: linkColor, color: '#fff' }}
                                    type="submit"
                                    value={isSubmitting ? '' : 'Update payment method'}
                                />
                            </div>
                        )}
                        onSubmit={async (e, data) => {
                            // paynow???
                            console.log('onSubmit', data)

                            const preSubmitErrors = Object.values(data.preSubmitHookResults).find(
                                (preSubmitHookResult) => {
                                    const { error } = preSubmitHookResult || {}
                                    return !!error
                                },
                            )

                            if (preSubmitErrors?.error) {
                                throw new Error(preSubmitErrors.error)
                            }
                        }}
                        conditions={{
                            payment: {
                                required: true,
                                isComplete: false,
                                Component: (ownProps) => (
                                    <Form
                                        onSubmit={() => { }}
                                        render={() => (
                                            <>
                                                {paymentFields.map((Field) => (
                                                    <Field
                                                        {...ownProps}
                                                        existingPaymentMethods={paymentMethodsData}
                                                        defaultPaymentMethod={defaultPaymentMethod}
                                                        linkColor={linkColor}
                                                        publisherName={publisherName}
                                                        CardElement={CardElement}
                                                    />
                                                ))}

                                            </>
                                        )}
                                    />
                                ),
                                preSubmit: async (data) => {
                                    const {
                                        state: {
                                            payment: {
                                                selectedPaymentMethod,
                                                account_id: accountId,
                                                public_token: publicToken,
                                                isComplete,
                                            } = {},
                                        } = {},
                                    } = data

                                    if (!isComplete) {
                                        return false
                                    }

                                    let stripeData

                                    switch (selectedPaymentMethod) {
                                        case 'add_bank_account':
                                            if (!accountId) {
                                                throw new Error('unable to determine bank account id')
                                            }

                                            if (!publicToken) {
                                                throw new Error('unable to determine bank public token')
                                            }

                                            await observers.addPaymentMethod({
                                                dispatch,
                                                payload: {
                                                    token: {
                                                        accountId,
                                                        id: publicToken,
                                                        type: 'bank',
                                                    },
                                                    publisherId,
                                                },
                                            })

                                            break

                                        case 'add_card':
                                            stripeData = await stripe.createToken(
                                                elements.getElement(CardElement),
                                            )

                                            await observers.addPaymentMethod({
                                                dispatch,
                                                payload: {
                                                    token: stripeData.token,
                                                    publisherId,
                                                },
                                            })

                                            break

                                        default:
                                            await observers.setDefaultPaymentMethod({
                                                dispatch,
                                                payload: {
                                                    sourceId: selectedPaymentMethod,
                                                    publisherId,
                                                },
                                            })

                                            break
                                    }

                                    return null
                                },
                            },
                        }}
                        postSubmit={(data) => {
                            // check postSubmit for errors
                            // inform the wizard we're done
                            console.log('postSubmit', data)
                            form.submit()
                            onUpdateSuccess()
                            // throw new Error('oops')
                        }}
                    />
                )}
            />
        </WizardSlider>
    )
}

export default (props) => (
    <StripeDecorator
        stripePublicKey={process.env.REACT_APP_STRIPE_PUBLIC_KEY}
    >
        <CardEditor {...props} />
    </StripeDecorator>
)
